import { render } from "./PopupConfirmationEmail.vue?vue&type=template&id=2b44e7c2&scoped=true"
import script from "./PopupConfirmationEmail.vue?vue&type=script&lang=js"
export * from "./PopupConfirmationEmail.vue?vue&type=script&lang=js"

import "./PopupConfirmationEmail.vue?vue&type=style&index=0&id=2b44e7c2&scoped=true&lang=css"

import exportComponent from "F:\\homework\\tokenza\\tokenza_airdrop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b44e7c2"]])

export default __exports__